import type { ClaimsView } from '@cyberscore/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useSession } from '../../lib/session';

const key = (t: string | undefined, id: string) => ['assessments', t, id] as const;

/** Claim checks of the current answers (task 62). */
export function useClaims(id: string, enabled = true) {
  const { tenant } = useSession();
  return useQuery({
    queryKey: [...key(tenant?.id, id), 'claims'],
    queryFn: () => api<ClaimsView>('GET', `/assessments/${id}/claims`),
    enabled: !!tenant && enabled,
  });
}

export type ClaimsRun = ClaimsView & { checked: number; changed: number; failed: number };

/** Runs every check again; the review, score and claims reload. */
export function useRunClaims(id: string) {
  const qc = useQueryClient();
  const { tenant } = useSession();
  return useMutation({
    mutationFn: () => api<ClaimsRun>('POST', `/assessments/${id}/claims/run`),
    onSettled: () => qc.invalidateQueries({ queryKey: key(tenant?.id, id) }),
  });
}
